var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Ui-Button"},[_c('a',{attrs:{"href":"https://lowcarboyui.base.shop","target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"online"},[_vm._v(" 結のオンラインショップはコチラ ")])])]),_c('p',{staticClass:"text_Ui-Button"},[_vm._v(" ミツバチ食堂の店内でも購入"),_c('br',{staticClass:"sp"}),_vm._v("（イートイン・テイクアウト）できます。 ")])])
}]

export { render, staticRenderFns }